<template>
  <draggable
    :group="{ name: 'module', put: false, pull: 'clone' }"
    :sort="false"
    :value="childModules"
    class="topic-drag"
  >
    <div v-for="item in childModules" :key="item.code" class="topic-item-box">
      <div class="tx-c bg-w pic-box mb20">
        <img :src="item.topicFileUrl" alt="" width="100%" height="106px" />
        <p class="font-16 lh30 ellipsis">{{ item.topicName }}</p>
        <div class="font-12 grey flex-box serve-list">
          <template v-for="(ee, ii) in item.serveList">
            <div class="serve-item " >{{ee.serveName}}</div>
            <span style="line-height: 12px" v-if="ii<item.serveList.length-1">&nbsp;|&nbsp;</span>
          </template>
        </div>
        <div class="selected" v-if="ifSelected(item)">已选</div>
      </div>
    </div>
  </draggable>
</template>

<script>
import draggable from "vuedraggable";
export default {
  name: "topicC",
  components: { draggable },
  props: ["childModules", 'homeModules'],
  data() {
    return {};
  },
  created() {
  },
  computed: {},
  methods: {
    addClick(data) {
      this.$emit("addClick", data);
    },
    ifSelected(val){
      let topicModule = this.homeModules.find(item => item.cardType === 'TOPIC')
      if(topicModule){
        if(topicModule.cardModules[0].data){
          return topicModule.cardModules[0].data.some(item => item.topicId === val.topicId)
        }
        return false
      }
      return false
    }
  },
  watch: {},
  filters: {},
};
</script>

<style lang="less" >
.topic-item-box {
  display: flex;
  justify-content: center;
  .pic-box {
    border: 1px solid #ddd;
    cursor: move;
    overflow: hidden;
    // .serve-item {
    //   line-height: 24px;
    // }
  }
}
.topic-drag{
  .serve-item {
    line-height: 12px !important;
  }
}
</style>